import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { InvoiceEditorPage } from "@/features/invoiceeditor/InvoiceEditorPage";

const search = z.object({
  view: z.enum(["form", "preview"]).optional(),
});

export const Route = createFileRoute("/_app/invoices/$invoice")({
  validateSearch: search,
  component: Page,
});

function Page() {
  const { invoice } = Route.useParams();
  return <InvoiceEditorPage id={invoice} search={Route.useSearch()} />;
}
